export const ALPHANUMERIC_ONLY = /^\w+$/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE = /^(\+)?(\d|\s)*$/;
export const TIME_REGEX = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
